export const YEAR_FIRST_CAR_WAS_MANUFACTURED = 1886;
